import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ScrollArea } from "@/components/ui/scroll-area";
import { getBikeRepairHistory } from "@/integrations/supabase/inventory-services";
import { Bike } from "@/types/models";
import { BikeRepairHistory } from "@/types/inventory";

interface RepairHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  bike: Bike | null;
}

const RepairHistoryModal = ({ isOpen, onClose, bike }: RepairHistoryModalProps) => {
  const { data: history, isLoading, error } = useQuery<BikeRepairHistory[]>({
    queryKey: ['bike-repair-history', bike?.id],
    queryFn: () => getBikeRepairHistory(bike?.id || ''),
    enabled: !!bike && isOpen,
  });

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-3xl">
        <DialogHeader>
          <DialogTitle>Historial de Reparaciones</DialogTitle>
          {bike && (
            <DialogDescription>
              Mostrando el historial para la bicicleta #{bike.number} - {bike.model}.
            </DialogDescription>
          )}
        </DialogHeader>
        <ScrollArea className="h-[400px] mt-4">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Fecha</TableHead>
                <TableHead>Repuesto Utilizado</TableHead>
                <TableHead>Cantidad</TableHead>
                <TableHead>Realizado por</TableHead>
                <TableHead>Notas</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center">Cargando historial...</TableCell>
                </TableRow>
              ) : error ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center text-red-500">Error al cargar el historial.</TableCell>
                </TableRow>
              ) : history?.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} className="text-center">No hay reparaciones registradas para esta bicicleta.</TableCell>
                </TableRow>
              ) : (
                history?.map((entry) => (
                  <TableRow key={entry.id}>
                    <TableCell>{new Date(entry.assignment_date).toLocaleDateString()}</TableCell>
                    <TableCell>{entry.spare_part_type?.name || 'N/A'}</TableCell>
                    <TableCell>{entry.quantity_used}</TableCell>
                    <TableCell>{entry.profile?.full_name || 'N/A'}</TableCell>
                    <TableCell className="max-w-xs truncate">{entry.notes || '-'}</TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </ScrollArea>
      </DialogContent>
    </Dialog>
  );
};

export default RepairHistoryModal;
